export const newsData = [
  {
    id: 1,
    title: "Tránsito en San Francisco: implicancias legales de un fallo reciente",
    summary:
      "Análisis jurídico de un caso reciente vinculado al tránsito en la ciudad de San Francisco, abordando la responsabilidad del conductor y las consecuencias legales derivadas del fallo.",
    image: "/Noticia.png", // después podés cambiarla por una real
    link: "https://www.lavoz.com.ar/ciudadanos/transito-san-francisco_0_7dvX3XKoeL.html",
    category: "Derecho Civil",
    date: "2026",
  },
];